// extracted by mini-css-extract-plugin
export var logo = "_k9-2";
export var logoWrapper = "_k9-1";
export var strip = "_k9-0";